// Marker detection and handling module for ChatWidget

// List of valid markers we support (XML-style tags)
export const VALID_MARKERS = [
    'REDIRECT',
    'CAPTURE_DETAILS',
    'CAPTURE_EMAIL',
    'CAPTURE_PHONE',
    'CAPTURE_APPOINTMENT',
    'CAPTURE_CONVERSATION',
    'CONTACT_US_FORM',
    'TEXT_RESPONSE',     // Internal: used for response rule text
    'RULE_ID',           // Internal: identifies response rules
    'LINK',
    'VEHICLELINK',
    'OPTION'             // Internal: multi-option button format
];

// Helper function to strip unknown markers from text (XML-style tags)
export function stripUnknownMarkers(text) {
    if (!text) return text;

    // Find all XML-style markers in the text: <MARKER ... /> or <MARKER>
    return text.replace(/<([A-Z_]+)(?:\s+[^>]*)?\s*\/?>/gi, (match, markerName) => {
        // Check if this marker is in our valid list
        if (VALID_MARKERS.includes(markerName.toUpperCase())) {
            // This is a valid marker, keep it
            return match;
        }

        // Unknown marker, strip it out
        return '';
    });
}

// Strip all capture-related markers from text (used after details are already captured)
export function stripCaptureMarkers(text) {
    if (!text) return text;
    return text
        .replace(/<CAPTURE_DETAILS\s*\/?>/gi, '')
        .replace(/<CAPTURE_EMAIL\s*\/?>/gi, '')
        .replace(/<CAPTURE_PHONE\s*\/?>/gi, '')
        .replace(/<CAPTURE_APPOINTMENT\s*\/?>/gi, '')
        .replace(/<CONTACT_US_FORM\s*\/?>/gi, '')
        .trim();
}

// Helper function for flexible marker matching (XML-style tags)
// Checks for markers like <MARKER /> or <MARKER attr="..." />
export function hasMarker(text, markerName) {
    if (!text) return false;

    // Extract marker name from input (e.g., "CAPTURE_DETAILS" or "<CAPTURE_DETAILS />")
    const cleanMarkerName = markerName.replace(/<|>|\/|\s/g, '').toUpperCase();

    // Create regex to match XML-style tag (self-closing or opening tag)
    // Matches: <MARKER />, <MARKER/>, <MARKER attr="..." />, <MARKER>
    const regex = new RegExp(`<${cleanMarkerName}(?:\\s+[^>]*)?\\/?>`, 'i');

    // Try exact match first
    if (regex.test(text)) return true;

    const upperText = text.toUpperCase();

    // Handle common LLM typos in CAPTURE tags
    if (cleanMarkerName.includes('CAPTURE')) {
        const variations = [
            cleanMarkerName.replace('CAPTURE', 'CAPTUR'),   // Missing E
            cleanMarkerName.replace('CAPTURE', 'CATURE'),   // Missing P
            cleanMarkerName.replace('CAPTURE', 'CATPURE'),  // Swapped PT
            cleanMarkerName.replace('CAPTURE', 'CAPURE'),   // Missing T
            cleanMarkerName.replace('_', ''),                // Missing underscore
        ];

        return variations.some(v => {
            const varRegex = new RegExp(`<${v}(?:\\s+[^>]*)?\\/?>`, 'i');
            return varRegex.test(upperText);
        });
    }

    return false;
}
